export default "https://cdn-static.gokick.com/assets/392c20f622263512bf2611e9ba1d645afacce893/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";